import {WatchlistType} from "./WatchlistType";
import {WatchlistModels} from "./WatchlistModel";
import {ObjectUtil} from "../../js/util/ObjectUtil";
import {WatchlistId} from "./WatchlistId";

export type WatchlistSummaries = ReadonlyArray<WatchlistSummary>;

export interface WatchlistSummary {
    readonly id: WatchlistId;
    readonly name: string;
    readonly type: WatchlistType;
}

export function BuildSummaries(models: WatchlistModels): WatchlistSummaries {
    return models.map((model) => ObjectUtil.pick(model, "id", "name", "type"));
}
